import React, {PureComponent} from "react";
import {observer, inject} from 'mobx-react';
import validate from 'validate.js';
import HttpClient from 'services/HttpClient';
import {PageWrapper} from '../components/PageWrapper';
import ResourceForm from '../components/ResourceForm';
import {RESOURCE_CONSTRAINS} from 'constants/adminPupups';

const resourceUrl = '/api/v1/resourses';

@inject('resourcesStore')
@inject('alertStore')
@inject('examPrepHeaderStore')
@observer
class AddResource extends PureComponent {
  componentDidMount() {
    const {resourcesStore} = this.props;
    resourcesStore.initNewResource();
  }

  handleChange = e => {
    const {resourcesStore} = this.props;

    if (e.target.name === 'file') {
      resourcesStore.handleChange({[e.target.name]: e.target.files[0]});
    } else {
      resourcesStore.handleChange({[e.target.name]: e.target.value});
    }
  };

  validationProcess = resource => {
    let errors = validate(resource, RESOURCE_CONSTRAINS, { fullMessages: false });

    return errors
  };

  submit = e => {
    e.preventDefault();

    const {resourcesStore, examPrepHeaderStore} = this.props;
    const {topic} = examPrepHeaderStore;
    const resource = _.assign({}, resourcesStore.resource);
    const errors = this.validationProcess(resource);

    resourcesStore.setError(errors);

    if (errors) {
      return;
    }

    const formData = new FormData();
    formData.append('title', resource.title);
    formData.append('file', resource.file, resource.file.name);
    formData.append('resourse_type', resource.resourse_type);

    new HttpClient().multipart(resourceUrl, formData, 'POST').then(data => {
      resourcesStore.saveResource(data.body.data.resourse);
      resourcesStore.initNewResource();
      this.props.alertStore.success('You successfully created OSCE');
      this.props.history.push(`/exam-prep/${topic.id}/practice-cases`);
      
    }).catch((e) => {
      console.log(e)
      this.props.alertStore.success('Something went wrong');
      // this.handleUnsuportableEntity(e)
    });
  };

  render() {
    return (
      <PageWrapper>
        <ResourceForm submit={this.submit} />
      </PageWrapper>
    );
  }
};

export default AddResource;



// WEBPACK FOOTER //
// ./src/modules/resources/containers/AddResource.js